import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import 'font-awesome/css/font-awesome.css';
import './HeaderButton.css';

class HeaderButtonClass extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      buttonText: this.props.buttonText,
      buttonImage: this.props.iconClass,
      linkto: this.props.linkto,
    };
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    this.setState({
      buttonText: newProps.buttonText,
      buttonImage: newProps.iconClass,
      linkto: newProps.linkto,
    });
  }

  handleClick = () => {
    if (this.state.linkto !== 'makecall') {
      this.props.navigate(`/${this.state.linkto}`);
    } else {
      this.props.callFunc();
    }
  };

  handleKeyPress = () => {
    this.props.navigate(`/${this.state.linkto}`);
  };

  render() {
    return (
      <div id={this.props.id} className="header-button col-xs-6 center">
        <div>
          <div
            role="button"
            onClick={this.handleClick}
            onKeyPress={this.handleKeyPress}
            tabIndex={0}
          >
            <img
              className="footer-icon"
              alt={this.state.buttonText}
              src={this.state.buttonImage}
            />
          </div>
          <div className="small footer-label">{this.state.buttonText}</div>
        </div>
      </div>
    );
  }
}

HeaderButtonClass.propTypes = {
  buttonText: PropTypes.string.isRequired,
  iconClass: PropTypes.string.isRequired,
  linkto: PropTypes.string.isRequired,
  callFunc: PropTypes.func,
  id: PropTypes.string.isRequired,
  navigate: PropTypes.func.isRequired,
};

HeaderButtonClass.defaultProps = {
  callFunc: () => false,
};

function HeaderButton(props) {
  const navigate = useNavigate();
  return <HeaderButtonClass {...props} navigate={navigate} />;
}

export default HeaderButton;
